import store from "./store"
import { isEmpty } from "../libs/validation/validators";
import cookie from "../libs/cookie/client";

var isLoggedIn = () => {
  var json = store.api.getJSON(store.data.USERDATA);
  if (json != null) {
    return true;
  } else {
    return false;
  }
}

var isLoggedIn = () => {
  var ck = (cookie.getItem && typeof cookie.getItem === 'function' && cookie.getItem('secretKey') === 'allowmein');
  if (!ck) {
    var json = store.api.getJSON(store.data.USERDATA);
    // if (json != null) {

    // }
    if (!isEmpty(cookie.getItem('authorizationKey'))) {
      return true;
    }
    return false;
  }
  return true;
}

export default {
  getAuthKey: () => {
    if (isLoggedIn()) {
      var auth = (cookie.getItem && typeof cookie.getItem === 'function' && cookie.getItem('authorizationKey'));
      if (!isEmpty(auth))
        auth = decodeURIComponent(auth);
      if (isEmpty(auth)) {
        // var json = store.api.getJSON(store.data.USERDATA);
        // if (json != null) {
        //   return json["authorizationKey"];
        // }
        return cookie.getItem('authorizationKey')
      }
      else return auth;
    }
    return null;
  },
  getTokenKey: () => {
    if (isLoggedIn()) {
      var auth = (cookie.getItem && typeof cookie.getItem === 'function' && cookie.getItem('refreshToken'));
      if (!isEmpty(auth))
        auth = decodeURIComponent(auth);
      if (isEmpty(auth)) {
        var json = store.api.getJSON(store.data.USERDATA);
        if (json != null) {
          return json["refreshTokenCode"];
        }
      }
      else return auth;
    }
    return null;
  },
  isLoggedIn: () => {
    return isLoggedIn();
  },
  logout: () => {
    if (isLoggedIn()) {
      var json = store.api.getJSON(store.data.USERDATA);
      if (json != null) {
        json["authorizationKey"] = null;
        store.api.setJSON(store.data.USERDATA, json);
      }
      cookie.removeItem('authorizationKey');
    }
  },
  login: (data) => {
    cookie.setItem('authorizationKey', data.authorizationKey);
    cookie.setItem('username', data.username);
    cookie.setItem('email', data.username);
    cookie.setItem('userid', data.email);
    store.api.setJSON(store.data.USERDATA, data);
  },
  updateTokenKeys: (data) => {
    cookie.setItem('authorizationKey', data.authorizationKey);
  }
};

